import i18next from "i18next";

interface LoaderProps {
	visible: boolean;
}

const AppLoader = ({ visible }: LoaderProps) => {
	if (!visible) return null;

	return (
		<div
			style={{ zIndex: 10000 }}
			className="d-flex w-100 h-100 bg-white position-absolute justify-content-center align-items-center"
		>
			<div>
				<h2>{i18next.t("initializing-app")}</h2>
				<h6 className="text-center">{i18next.t("please-wait")}</h6>
			</div>
		</div>
	);
};

export default AppLoader;
